module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","display":"standalone","name":"Merkl Kinga","short_name":"Merkl Kinga - Fotós","background_color":"#c49b82","theme_color":"#c49b82","start_url":"/","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0447bfcdd8d1ce3990bae8e281e6d9c1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
